import { DropdownContent, DropdownWrapper } from '@anm/components/Dropdown';
import getFromCdn from '@anm/helpers/getFromCdn';
import { blackFilter } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

export const DropdownButton = styled.div`
  color: var(--gray_500);
  font-weight: 700;
  background-color: transparent;
  width: 100%;
  justify-content: flex-start;
  border-radius: 10px 10px 0 0;
  position: relative;
  z-index: 135;
  transition: all 200ms ease-in-out;

  &:hover,
  &:focus {
    background-color: transparent;
  }
`;

const topStyles = css`
  ${DropdownWrapper}:before {
    top: -15px;
    bottom: unset;
  }
  ${DropdownButton} {
    border-radius: 0 0 10px 10px;
  }
  ${DropdownContent} {
    transition: none;
    border-radius: 10px 10px 0 0;
    transform: translateY(calc(-100% - 50px));
  }
`;

export const DropdownButtonWrapper = styled.div<{ isTop: boolean }>`
  position: relative;
  &:before {
    content: '';
    display: block;
    width: 10px;
    height: 10px;
    position: absolute;
    right: 16px;
    top: 22px;
    z-index: 137;
    background-image: url(${getFromCdn('images/icons/ddwn-arrow.svg')});
    background-position: center;
    background-repeat: no-repeat;
    transform: rotate(180deg);
    pointer-events: none;
  }

  ${DropdownContent} {
    width: 100%;
    border-radius: 0 0 10px 10px;
    top: 100%;
    right: 0;
    transition: all 200ms ease-in-out;
    box-shadow: none;
  }
  &:hover {
    &:before {
      transform: rotate(0);
    }
    ${DropdownButton} {
      background-color: var(--white);
      color: var(--gray_900);

      &:before {
        filter: ${blackFilter};
      }
    }
    ${DropdownWrapper} {
      &:before {
        opacity: 1;
      }
    }
    ${DropdownContent} {
      box-shadow: 0 2px 10px rgba(1, 83, 130, 0.1);
    }
  }
  ${({ isTop }) => isTop && topStyles};
`;

export const DropdownContentItem = styled.a``;

export const DropdownContentWrapper = styled.ul`
  ${DropdownContentItem} {
    color: var(--gray_500);
    font-weight: bold;
    &:hover {
      background-color: var(--white);
      color: var(--gray_900);
    }
  }
`;
